// extracted by mini-css-extract-plugin
export var activeTab = "tabbed-content-pills-module--activeTab--60134";
export var tab = "tabbed-content-pills-module--tab--88089";
export var tabContainer = "tabbed-content-pills-module--tabContainer--4cd7d";
export var tabIndicator = "tabbed-content-pills-module--tabIndicator--0c368";
export var tabs = "tabbed-content-pills-module--tabs--c6176";